import { Injectable } from '@angular/core';
import { Login } from '../../interfaces/interfaces/login';
import { ContentManagementService } from '../content-management/content-management.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public static userSessionLogout = new Subject();

  constructor(private contentService: ContentManagementService) {}

  logout(): void {
    this.contentService.setQueryParams(null);
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.removeItem('userToken');
    AuthService.userSessionLogout.next();
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('userToken') ;
  }

}
